import React, { Component } from 'react';

export const isEmpty = (value) => {
	if (Array.isArray(value)) return value.length === 0;
	if (value && typeof value === 'object') return Object.keys(value).every(key => isEmpty(value[key]));
	return !value; // check for null, undefined, or empty string
};

export const formatData = (obj) => {
	const convert = (str) => {

		const customRuleKey = {
			nwbMotion: 'NWB Range of Motion',
			mla: 'MLA',
			tmtEversion: 'TMT Eversion',
			tmtInversion: 'TMT Inversion',
			nwbObservations: 'NWB Observations',
			wbMotion: 'WB Range of Motion',
			lr: 'LR',
			rl: 'RL',
			amPain: 'AM Pain',
			otc: 'OTC',
			tma: 'TMA',
			bka: 'BKA',
			mtpjRangeOfMotion: 'MTPJ Range of Motion',
			stjRangeOfMotion: 'STJ Range of Motion',
			msk: 'MSK',
			tbd: 'TBD',
			havBunion: 'HAV / Bunion',
			inc: 'INC',
			dec: 'DEC',
			ankleRangeOfMotion: 'Ankle Range of Motion',
			otherRangeOfMotionComments: 'Other Range of Motion Comments',
			foamsCreamsRecommentations: 'Foams/Creams Recommendations',
			mm: 'mm',
			dtr: 'DTR',
			relationships: 'Rearfoot to Forefoot Relationship',
			ulcerations: 'Calluses, Corns and Ulcerations',
			hallux: 'Hallux Abducto Valgus',
			fatPad: 'Fat Pad Atrophy',
			dependantRubor: 'Dependent Rubor / Pallor / Cyanosis',
			crepitus: 'Crepitus / Effusion',
			fabricationsInstructions: 'Fabrication Instructions',
			afo: 'AFO',
			scfo: 'SCFO',
			otcInsole: 'OTC Insole',
			leftString: 'Left',
			rightString: 'Right',
			eva20: 'EVA 20 Shore',
			eva30: 'EVA 30 Shore',
			eva40: 'EVA 40 Shore',
			eva50: 'EVA 50 Shore',
			eva60: 'EVA 60 Shore',
			degrees: 'deg',
			capillaryFillingTimeSec: 'Capillary Filling Time',
			firstRayCutOut: '1st Ray Cut-out',
			firstRayCutOutComments: '1st Ray Cut-out Comments',
			twoFiveBar: '2-5 Bar',
			twoFiveBarComments: '2-5 Bar Comments',
			rigidFirstExtension: 'Rigid 1st Extension',
			rigidFirstExtensionComments: 'Rigid 1st Extension Comments',
			heelToe: 'Heel to Toe',
			heelBall: 'Heel to Ball',
			plantarFlexedFirstRay: 'Plantar Flexed 1st Ray',
			willReturnInWeeks: 'Will Return in Weeks',
			willReturnInWeeksOther: 'Will Return in Weeks Other',
		}

		if (str in customRuleKey) {
			return customRuleKey[str]
		}

		// check if the string contains '>', '<', or '=' and apply custom formatting
		if (/[><=]/.test(str)) {
			return str
				.replace(/([lrLR])([<>=])([lrLR])/g, (match, left, operator, right) =>
					`${left.toUpperCase()} ${operator} ${right.toUpperCase()}`
				)
				.trim();
		}

		// formats camel casing
		return str
			.replace(/([a-z0-9])([A-Z])/g, '$1 $2') // adds space before single uppercase letters
			.replace(/([A-Z]+)([A-Z][a-z])/g, '$1 $2') // adds space in sequences like "aPDF"
			.replace(/([a-zA-Z])(\d)/g, '$1 $2') // adds space before numbers following letters
			.replace(/^./, (match) => match.toUpperCase()) // capitalize the first letter
			.trim(); // remove any leading/trailing whitespace
	};

	const format = (input) => {
		if (Array.isArray(input)) {
			return input
				.map(format)
				.filter(item => !isEmpty(item)); // filter out empty values from arrays
		} else if (input && typeof input === 'object') {
			const filteredEntries = Object.entries(input)
				.map(([key, value]) => [
					convert(key),
					format(value),
				])
				.filter(([key, value]) => !isEmpty(value)); // filter out empty values

			return Object.fromEntries(filteredEntries); // create a new object from filtered entries
		} else if (typeof input === 'string') {
			return convert(input);
		}
		return input;
	};

	return format(obj);
};

export class AssessmentInnerContainer extends Component { 
	render() { 

		return (
			<div className="Exam__details-inner-container">
				<div className="Exam__details">
					<h3 className="Exam__details-header">{this.props.header}:</h3>
					<div className="Exam__details-text">
						{this.props.children}
					</div>
				</div>
			</div>
		);
	}
}

export const valueThenSubTextDivs = ({value = null, label = '', units = ''} = {}) => {
	if (value) {
		if (Array.isArray(value)) {
			return label
				? <div className='Exam__details-sub-text'>{`${label}: ${value.join(`${units && units}, `)}`}</div> 
				: <div className='Exam__details-sub-text'>{value.join(`${units && units}, `)}</div>
		}
		
		if (typeof value === 'object') {
			const excludeKeys = ['Value', 'Values', 'Appropriateness']
			let rightIndex
			let leftIndex
			const divs = Object.keys(value).filter(key => key !== 'Comments').map((key, i) => {
				rightIndex = (key === 'Right') && i
				leftIndex = (key === 'Left') && i
				return Array.isArray(value[key])
					? <div className='Exam__details-sub-text' key={i}>{excludeKeys.includes(key) ? '' : `${key}: `}{value[key].join(`${units && units}, `)}</div>
					: <div className='Exam__details-sub-text' key={i}>{excludeKeys.includes(key) ? '' : `${key}: `}{value[key]}{units && units}</div>
			})

			// if Left and Right values exist, splice Left value after Right value
			if (value.Left && rightIndex) {
				Array.isArray(value.Left)
					? divs.splice(rightIndex + 1, 0, <div className='Exam__details-sub-text' key={divs.length}>Left: {value.Left.join(`${units && units}, `)}</div>)
					: divs.splice(rightIndex + 1, 0, <div className='Exam__details-sub-text' key={divs.length}>Left: {value.Left}{units && units}</div>)
				// remove original Left value from divs map
				divs.splice(leftIndex, 1)
			}
			
			// if Comments exist, add to end of divs
			if (value.Comments) {
				divs.push(
					<div className='Exam__details-sub-text' key={divs.length}>
						{`Comments: ${value.Comments}`}
					</div>
				)
			}
			return label
				? <React.Fragment><div className='Exam__details-sub-text'>{label}</div>{divs}</React.Fragment> 
				: divs
		}

		return label
			? <div className='Exam__details-sub-text'>{`${label}: ${value}${units && units}`}</div> 
			: <div className='Exam__details-sub-text'>{value}{units && units}</div>
	}
}

export const valueThenSubHeaderSection = (header, value, units = '') => {
	if (value) {
		return (
			<React.Fragment>
				<h3 className="Exam__details-sub-header">{header}:</h3>
				{valueThenSubTextDivs({value: value, units: units})}
			</React.Fragment>
		)
	}
}




// WEBPACK FOOTER //
// ./src/views/Assessment/examUtils.js